export default __webpack_public_path__ + "static/media/token_CELO.29960902.svg";